import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import {createStore} from 'vuex'
import createdPersistedState from "vuex-persistedstate"
import jQuery from 'jquery'


const store = createStore({
    state() {
        return {

            HomePage: null,
            Profile : null,
            Cards: null,
            Info: null,

            // **************************************************************

            order: {
                //ADD 'order_count_select' to products **
                products: [],
                orders_count: 0,
                orders_price: 0,
                orders_all_price: 0,
                orders_profit: 0,
                factor: false,
                offer: false,
            }

        }
    },
    mutations: {

        set_HomePage(state, new_value) {

            state.HomePage = new_value

        },

        set_Profile(state, new_value) {

            state.Profile = new_value

        },

        set_Cards(state, new_value) {

            state.Cards = new_value

        },

        delete_Card(state, new_value) {

            state.Cards.forEach((item, index) => {
                if (item.id === new_value.id) {
                    state.Cards.splice(index, 1)
                }
            })

        },

        set_info(state, new_value) {

          state.Info = new_value

        },

        EmptyState(){
            store.replaceState({
                HomePage: null,
                Profile : null,
                Cards: null,
                Info: null,

                // **************************************************************

                order: {
                    //ADD 'order_count_select' to products **
                    products: [],
                    orders_count: 0,
                    orders_price: 0,
                    orders_all_price: 0,
                    orders_profit: 0,
                    factor: false,
                    offer: false,
                }
            })
        },

        // ************************************  سبد خرید  *******************************************

        ProductUpdate(state, newValue) {

            if (state.order.products.length > 0) {

                var found = true
                state.order.products.forEach((item) => {
                    if (found) {
                        if (item.pid == newValue.pid) {
                            item.shop.number = newValue.shop.number
                            item.shop.count = newValue.shop.count
                            item.shop.price = newValue.shop.price
                            item.shop.price_up = newValue.shop.price_up
                            if (item.shop.number < 1) {
                                store.commit('ProductDelete', item)
                            }
                            found = false
                        }
                    }
                })
                if (found) {
                    state.order.products.push(newValue)
                }
            } else {
                state.order.products.push(newValue)
            }

            var orders_count = 0
            store.state.order.products.forEach((item) => {
                orders_count = orders_count + item.shop.number
            })
            store.state.order.orders_count = orders_count

            var orders_price = 0
            store.state.order.products.forEach((item) => {
                orders_price = orders_price + parseInt(item.shop.price) * parseInt(item.shop.number)
            })
            store.state.order.orders_price = orders_price

            var orders_all_price = 0
            store.state.order.products.forEach((item) => {
                orders_all_price = orders_all_price + parseInt(item.shop.price_up) * parseInt(item.shop.number)
            })
            store.state.order.orders_all_price = orders_all_price


            let orders_profit = 0
            orders_profit = parseInt(store.state.order.orders_all_price) - parseInt(store.state.order.orders_price)
            store.state.order.orders_profit = orders_profit

        },

        ProductDelete(state, newValue) {
            var found = true
            state.order.products.forEach((item) => {
                if (found) {
                    if (item.pid == newValue.pid) {
                        var index = state.order.products.indexOf(item);
                        if (index !== -1) {
                            state.order.products.splice(index, 1);
                        }
                        found = false
                    }
                }
            })
        },

        set_factor(state, newValue) {
            state.order.factor = newValue
        },

        set_offer(state, newValue) {
            state.order.offer = newValue
        },

        EmptyBasket(state) {
            state.order.products = [];
            state.order.orders_count = 0;
            state.order.orders_price = 0;
            state.order.orders_all_price = 0;
            state.order.orders_profit = 0;
            state.order.factor = false
        },


    },

    plugins: [createdPersistedState()]

})

// localStorage.clear()
// store.commit('empty_state')


import "vuetify/styles";
import {createVuetify} from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import {aliases, fa} from 'vuetify/iconsets/fa'
import {mdi} from 'vuetify/iconsets/mdi';

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            fa,
            mdi,
        },
    },

});

import "../src/assets/css/bootstrap/css/bootstrap.min.css";
import "../src/assets/css/style.css";

const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(store);
app.use(jQuery);
app.mount("#app");
